import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route } from 'react-router-dom';

export default function ProtectedRoute(props) {

  const user = useSelector(state => state.user);

  const loginPath = '/login';
  const notAuthPath = '/not-authorized';

  // Session has not been fetched yet
  if ((user.level == 99 && user.isLoggedIn) || user.isAuthenticating) {
    return null;
  }

  if (user.isLoggedIn) {
    if (props.level !== undefined) {
      if ( !((props.level).includes(user.level)) ) {
        return <Navigate to={notAuthPath} replace />;
      }
    }
    return props.element;
  }
  
  return <Navigate to={loginPath} replace />;
}
